import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import cd from 'debug';
import { compose } from 'redux';
import core, { App, Viewport } from '@gin-betting/core';
import matchList, { Pagination } from '@gin-betting/match-list';

import { State } from 'types';
import {
    withBettingReadyIndicatorContext,
    BettingReadyIndicatorContextProps,
} from 'modules/betting-ready-indicator';
import { AsyncFreebetPanel } from 'modules/freebet/async';
import UpcomingMatchList from '../Upcoming/UpcomingMatchList';
import PaginationWrapper from '../PaginationWrapper';
import './prematchList.scss';
import { OwnProps } from '../SportEventRow/Markets/MarketHcp';

const debug = cd('app:match-list:components:Prematch');

const {
    utils: { isFetchFinished },
} = core;

const {
    utils: { getFiltersFromLocation },
    viewport: {
        selectors: { makeViewportSelector },
    },
} = core;

const {
    pagination: {
        actions: { dropPaginationState, setMinAndMaxPages },
        hocs: { withPagination },
        selectors: {
            selectPaginationByLocation,
            selectDirection,
            selectIsInitialLoad,
        },
    },
    selectors: { selectCategoryByLocation },
} = matchList;

interface MappedCommonProps extends Pagination.NeededPaginationProps {
    lessThanOrEqual: Viewport.Breakpoints;
}

interface MappedActions {
    dropPaginationState: Pagination.DropPaginationStateFn;
    setMinAndMaxPages: Pagination.SetMinAndMaxPagesFn;
}

type Props = MappedCommonProps &
    RouteComponentProps &
    Partial<Pagination.ReturnedPaginationProps> &
    MappedActions &
    BettingReadyIndicatorContextProps;

class PrematchList extends React.Component<Props> {
    componentDidUpdate() {
        const {
            categoryData: { fetchStatus },
            readyIndicator,
        } = this.props;

        if (isFetchFinished(fetchStatus)) {
            readyIndicator.setReady();
        }
    }

    render() {
        debug('render', this.props);

        const {
            lessThanOrEqual,
            categoryData,
            hasNext,
            hasMore,
            isUp,
            matchIdsWithVisibilityFlags,
            visibilityInitRef,
            handleVisibilityChange,
            loadMoreWithPagination,
        } = this.props;

        const { fetchStatus, matchIds } = categoryData;

        const isMedium = lessThanOrEqual.medium;
        const isSmall = lessThanOrEqual.small;
        const { freeBetId: freebetId } = getFiltersFromLocation();

        return (
            <PaginationWrapper
                hasNext={hasNext}
                pollerName={App.PollerName.Prematch}
                fetchStatus={fetchStatus}
                matchIdsSize={matchIds.size}
                setMinAndMaxPages={this.props.setMinAndMaxPages}
                hasMore={hasMore}
                isUp={isUp}
                dropPaginationState={this.props.dropPaginationState}
                loadMoreWithPagination={loadMoreWithPagination}
                isMedium={isMedium}
            >
                {freebetId && (
                    <div styleName="freebet-wrapper">
                        <AsyncFreebetPanel freebetId={freebetId} />
                    </div>
                )}

                <UpcomingMatchList
                    isMedium={isMedium}
                    isSmall={isSmall}
                    matchIds={matchIdsWithVisibilityFlags || matchIds}
                    visibilityInitRef={visibilityInitRef}
                    handleVisibilityChange={handleVisibilityChange}
                />
            </PaginationWrapper>
        );
    }
}

const makeMapStateToProps = (
    state: State,
    ownProps: OwnProps & RouteComponentProps
): MappedCommonProps => {
    const {
        hasNext,
        minPage,
        currentPage,
        maxPage,
        limitPerPage,
    } = selectPaginationByLocation(state, ownProps);

    const categoryData = selectCategoryByLocation(state, ownProps);

    return {
        lessThanOrEqual: makeViewportSelector('lessThanOrEqual')(
            state,
            ownProps
        ),
        categoryData,
        hasNext,
        pages: {
            minPage,
            currentPage,
            maxPage,
            limitPerPage,
        },
        direction: selectDirection(state),
        isLoadInitial: selectIsInitialLoad(state),
    };
};

const mapDispatchToProps: MappedActions = {
    dropPaginationState,
    setMinAndMaxPages,
};

export default compose<React.ComponentClass>(
    withRouter,
    connect<MappedCommonProps, MappedActions>(
        makeMapStateToProps,
        mapDispatchToProps
    ),
    withPagination,
    withBettingReadyIndicatorContext
)(PrematchList);
